import * as Yup from "yup";

const formatDateToInput = (dateString) => {
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  let month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  let day = date.getUTCDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export function initialValues(paymentConcept) {
  return {
    name: paymentConcept?.name || "",
    amount: paymentConcept?.amount.toString() || "",
    dueDate: formatDateToInput(paymentConcept?.dueDate) || "",
  };
}

export function validationSchema() {
  return Yup.object().shape({
    name: Yup.string().required("El nombre es obligatorio"),
    amount: Yup.number()
      .required("El monto es obligatorio")
      .typeError("El monto debe ser un número válido"),
    dueDate: Yup.date()
      .required("La fecha de vencimiento es obligatoria")
      .typeError("La fecha de vencimiento debe ser una fecha válida"),
  });
}
